import { render, staticRenderFns } from "./ShareExperience.vue?vue&type=template&id=47715116&scoped=true"
import script from "./ShareExperience.vue?vue&type=script&lang=js"
export * from "./ShareExperience.vue?vue&type=script&lang=js"
import style0 from "./ShareExperience.vue?vue&type=style&index=0&id=47715116&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47715116",
  null
  
)

export default component.exports